<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name(:class="{ 'non-active-font': !active }") 利用者ごとの同時に予約可能な面会数
        span.validation-label(v-if="active") 必須
      .right-side
        slot(name="question")

    .register-value.concurrent-number-limit-radios(:class="[ { 'non-active': !active } ]")
      label.register-radio-label
        input#type-1.register-radio-form(
          v-model="_value"
          :name="name"
          type="radio"
          :value="0"
          v-validate="{ required: true }"
          data-vv-as="利用者ごとの同時に予約可能な面会数"
          :disabled="!active")
        span.register-radio-text 制限無し
      label.register-radio-label
        input#type-2.register-radio-form(v-model="_value" :name="name" type="radio" :value="1" :disabled="!active")
        span.register-radio-text 1件
      label.register-radio-label
        input#type-3.register-radio-form(v-model="_value" :name="name" type="radio" :value="2" :disabled="!active")
        span.register-radio-text 2件
      label.register-radio-label
        input#type-4.register-radio-form(v-model="_value" :name="name" type="radio" :value="3" :disabled="!active")
        span.register-radio-text 3件
      label.register-radio-label
        input#type-5.register-radio-form(v-model="_value" :name="name" type="radio" :value="4" :disabled="!active")
        span.register-radio-text 4件
      label.register-radio-label
        input#type-6.register-radio-form(v-model="_value" :name="name" type="radio" :value="5" :disabled="!active")
        span.register-radio-text 5件

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputConcurrentNumberLimit extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true, type: Number })
  value!: number;

  /** 活性にするか否か */
  @Prop({ default: true })
  active!: boolean;

  @Prop({ default: "concurrent-number-limit" })
  name!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): number {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: number) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

// ラジオボタンは横幅に応じてラップする
.concurrent-number-limit-radios {
  flex-wrap: wrap;
}
.right-side {
  margin-left: 8px;
}

.concurrent-number-limit-radios.non-active {
  .register-radio-text {
    color: $btn-font-disable !important;
    cursor: not-allowed !important;

    &:hover {
      background: $bg-default !important;
    }
  }
  .register-radio-form:checked + .register-radio-text {
    background: $btn-disable !important;
    color: $btn-font-disable !important;
    border: 1px solid $btn-disable !important;
  }
}
.non-active-font {
  color: $form-border-color;
}
</style>
